import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        originLenders: [],
        searchResults: [],
        info: {
            excludeLenderIds: '',
            useExternalUrl: false,
            totalLendersCount: 0,
            customLenders: [],
            autoSort: false,
            pageSize: 12,
            pageNum: 1,
            allTotal: 0
        }
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
